import React, { useState } from "react";
import { LeftRailHome } from "./layout/LeftRailHome";
import { HomeContent } from "./layout/HomeContent";
import { RightRailHome } from "./layout/RightRailHome";
import { ImprintPage } from "./assets/terms/ImprintPage";
import { DataPrivacy } from "./assets/terms/DataPrivacy";
import { CookiePolicy } from "./assets/terms/CookiePolicy";
import { Disclaimer } from "./assets/terms/Disclaimer";
import { Barrierefreiheit } from "./assets/terms/Barrierefreiheit";
import { TermsAGB } from "./assets/terms/TermsAGB";
import { SectionMenuLayer } from "./ui/SectionMenuLayer";



// --- Helper: initiale Seite aus URL bestimmen ---
function detectInitialPageFromUrl() {
  if (typeof window === "undefined") return "home";

  const legalPages = new Set([
    "imprint",
    "privacy",
    "cookies",
    "disclaimer",
    "bfsg",
    "terms",
  ]);

  try {
    const params = new URLSearchParams(window.location.search);
    const legal = params.get("legal");
    const hashRaw = window.location.hash || "";
    const hash = hashRaw.replace("#", "").toLowerCase();

    // Legal-Viewer aktiv?
    if (legal && legal !== "0") {
      if (legalPages.has(hash)) return hash;
      return "imprint"; // Default, falls kein/ungültiger Hash
    }
  } catch {
    // ignorieren, dann normale Startseite
  }

  return "home";
}

function detectBareLegalFromUrl() {
  if (typeof window === "undefined") return false;
  try {
    const params = new URLSearchParams(window.location.search);
    const legal = params.get("legal");
    return !!(legal && legal !== "0");
  } catch {
    return false;
  }
}

function App() {
  const [activeWorld, setActiveWorld] = useState(
    () => localStorage.getItem("lt.activeWorld") || ""
  );

  const [loadingWorld, setLoadingWorld] = useState(false);

  // NEU: ob wir im „Legal-Viewer“ sind (nur Mittelteil, kein Rail)
  const [bareLegal] = useState(() => detectBareLegalFromUrl());

  // NEU: welche „Seite“ im Mittelbereich?
  const [activePage, setActivePage] = useState(() => detectInitialPageFromUrl());

  const handleNavigate = (pageId) => {
    setActivePage(pageId);
  };

  const handleSelectWorld = (code) => {
    setActiveWorld(code);
    localStorage.setItem("lt.activeWorld", code);
  };

// ⬇⬇ HIER: Toggle-Funktion für das Hauptmenü
const onSectionMenu = (sec) => {
  setMenuSection((prev) => (prev === sec ? null : sec));
};



  const [menuSection, setMenuSection] = useState(null); // "01"..."05" oder null



  // Mittelteil umschalten
  const renderCenter = () => {
    if (activePage === "imprint") {
      return <ImprintPage />;
    }
    if (activePage === "privacy") {
      return <DataPrivacy />;
    }
    if (activePage === "cookies") {
      return <CookiePolicy />;
    }
    if (activePage === "disclaimer") {
      return <Disclaimer />;
    }
    if (activePage === "bfsg") {
      return <Barrierefreiheit />;
    }
    if (activePage === "terms") {
      return <TermsAGB />;
    }

    // Beispiel-Tools – erstmal nur Platzhalter:
  if (activePage === "tools-buildings") {
    return <div style={{ padding: 20 }}>Gebäuderechner – kommt bald 🚧</div>;
  }

  if (activePage === "off-sim") {
    return <div style={{ padding: 20 }}>Kampfsimulator – kommt bald 🚧</div>;
  }


    // Default: „normale“ Home-Startseite
    return (
      <HomeContent
        activeWorld={activeWorld}
        loadingWorld={loadingWorld}
        setLoadingWorld={setLoadingWorld}
      />
    );
  };

  // === LEGAL-VIEWER: nur Mittelspalte, kein Left/Right ===
  if (bareLegal) {
    return (
      <div
        style={{
          margin: 0,
          padding: 0,
          background:
            "radial-gradient(circle at top, #000000 100%, #070a0f 100%, #020308 100%)",
          color: "#e6edf3",
          fontFamily:
            'DisplayBadge, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
          minHeight: "100vh",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "824px",           // Mittelspalte
            maxWidth: "100%",
            margin: "0 auto",
            padding: "0",
            boxSizing: "border-box",
            height: "min(820px, 100vh)",
            display: "flex",
          }}
        >
          {renderCenter()}
        </div>
      </div>
    );
  }



  // === Normaler 3-Spalten-Home-Modus ===
  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        background:
          "radial-gradient(circle at top, #000000 100%, #070a0f 100%, #020308 100%)",
        color: "#e6edf3",
        fontFamily:
          'DisplayBadge, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
        minHeight: "100vh",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "250px 824px 338px",
          gap: "4px",
          background: "#000000",
          width: "1420px",
          maxWidth: "1420px",
          minWidth: "1420px",
          height: "min(820px, 100vh)",
          margin: "0 auto",
          padding: 0,
          boxSizing: "border-box",

          // WICHTIG: Overlay-Anchor
          position: "relative",
        }}
      >
        <LeftRailHome
          activeWorld={activeWorld}
          onSelectWorld={handleSelectWorld}
          loadingWorld={loadingWorld}
          onNavigate={setActivePage}
          onSectionMenu={onSectionMenu}   // ⬅ hinzufügen
        />

        {renderCenter()}
        <RightRailHome />

        {menuSection && (
          <SectionMenuLayer
          key={menuSection} 
            section={menuSection}
            onClose={() => setMenuSection(null)}
            onSelectPage={(pageId) => {
              setMenuSection(null);     // Menü schließen
              handleNavigate(pageId);   // Mittelteil umschalten
            }}
          />
        )}
      </div>
    </div>
  );
}


export default App;
